<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="600"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          Create {{ type?.toUpperCase() }}
        </h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--begin::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div class="row">
          <div class="col-12 h-75px">
            <v-datetime-picker
              ref="datetimePicker"
              :label="$t('expected_collection_date')"
              :textFieldProps="{
                outlined: true,
                clearable: true,
                dense: true,
                'prepend-icon': 'mdi-calendar',
                'error-messages': collectionDateError,
              }"
              :datePickerProps="{ min: new Date().toISOString().split('T')[0] }"
              :timePickerProps="{
                min: new Date().toLocaleTimeString(),
                'allowed-minutes': (m) => m % 5 === 0,
              }"
              dateFormat="yyyy-MM-dd"
              timeFormat="HH:mm"
              v-model="formData.expected_collection_date"
              @input="$v.formData.expected_collection_date.$touch()"
              @blur="$v.formData.expected_collection_date.$touch()"
            >
            </v-datetime-picker>
          </div>
        </div>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="my-2 mt-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submit"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { dateTimeFormatter } from "@/own/libs/helper";

export default {
  name: "CreateRvpRtoModal",
  mixins: [validationMixin],
  props: ["items", "updateTableContent", "type"],
  validations() {
    return {
      formData: {
        expected_collection_date: { required },
      },
    };
  },
  data: () => ({
    dialog: false,
    formData: {
      expected_collection_date: null,
    },
  }),
  methods: {
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("maxValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].maxValue &&
          errors.push(this.$t("validation_this_field_must_be_greater_than_0"));
      }
      if ("url" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].url &&
          errors.push(this.$t("validation_this_url_is_invalid"));
      }
      if ("numeric" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      if ("email" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].email &&
          errors.push(this.$t("validation_this_email_address_is_invalid"));
      }
      return errors;
    },
    toggleModal() {
      this.reset();
      this.dialog = !this.dialog;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      const payload = {
        orders: this.items.map((item) => item.systemId),
        expected_collection_date: dateTimeFormatter(
          this.formData.expected_collection_date
        ),
      };

      const url = {
        rvp: "order_rvp_create",
        rto: "order_rto_create",
      };
      ApiService.post(`/fulfillment/orders/${url[this.type]}`, payload)
        .then(({ data }) => {
          let editedItemMessage = `<div><ol>`;
          data.messages.forEach((item) => {
            editedItemMessage += `<li>${item}</li>`;
          });
          editedItemMessage = editedItemMessage + `</ol></div>`;
          Swal.fire({
            title: "Success",
            html: `${editedItemMessage}`,
            icon: data.error_orders === 0 ? "success" : "warning",
            showConfirmButton: true,
            // timer: 2500,
          });
          this.toggleModal();
          this.updateTableContent();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },

    reset() {
      this.formData = {
        expected_collection_date: null,
      };
      this.$refs?.datetimePicker?.clearHandler();
      this.$v.$reset();
    },
  },
  computed: {
    collectionDateError: function () {
      return this.handleFormValidation(
        "expected_collection_date",
        this,
        "formData"
      );
    },
    warehouses: function () {
      return this.$store.getters.getORDERSWarehouses;
    },
  },
  mounted() {},
};
</script>
